/** @jsx h */
import { showCount, labels } from '../config';
import Pagination from './Pagination';
import ResultTitle from './ResultTitle';

const TeaserGeneral = ({
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
}) => {
  function handleLoadMoreClick() {
    loadMore();
  }

  return (
    <div className="search__results">
      {allResultCount && showCount && (
        <header className="search__results-header">
          <ResultTitle allResultCount={allResultCount} />
          <span className="is-text-l">{labels.results.sortRelevance}</span>
        </header>
      )}

      <ul className="search__results-wrapper">
        {list &&
          list.map((result, index) => (
            <li className="search__results-item" key={index}>
              <div className="search-results__text-wrapper">
                {result.mark && (
                  <ul class="search__results-labels">
                    <span
                      className="search__results-label"
                      // eslint-disable-next-line
                        dangerouslySetInnerHTML={{ __html: result.mark }}
                    />
                  </ul>
                )}
                <h3 href={result.url} className="search-results__heading">
                  {result.title}
                </h3>
                {result.subtitle && (
                  <p className="is-text">{result.subtitle}</p>
                )}
                {result.teaser && (
                  <p className="search-results__copy is-text">
                    {result.teaser}
                  </p>
                )}
                <a
                  href={result.url}
                  className="link-internal is-text search-results__more"
                  {...(result.isExternal
                    ? { target: '_blank', rel: 'noopener' }
                    : '')}
                >
                  <span>{labels.results.readMore}</span>
                </a>
              </div>
            </li>
          ))}
      </ul>

      <Pagination
        pagination={pagination}
        triggerLoadMore={handleLoadMoreClick}
        pluginNamespace={pluginNamespace}
      />
    </div>
  );
};

export default TeaserGeneral;
